<template>
  <v-dialog
    v-model="show"
    max-width="440px"
    @click:outside="cancel"
  >
    <v-card class="pa-sm-8 pa-4">
      <v-card-title class="text-h6 pa-0 mb-1">
        Новая роль
      </v-card-title>
      <v-card-subtitle class="pa-0 mb-6">
        Права выдаются после создания
      </v-card-subtitle>

      <v-card-text class="pa-0">
        <v-form ref="form">
          <v-text-field
            v-model="name"
            :rules="[rules.required]"
            outlined
            dense
            hide-details="auto"
            label="Название"
            placeholder="Например, Оператор КЦ"
            @keyup.enter="save"
          ></v-text-field>
        </v-form>

        <p class="text--secondary text-sm mt-4 mb-0">
          Созданная роль пустая и не открывает ничего. Отметьте нужные разделы в её карточке.
        </p>
      </v-card-text>

      <v-card-actions class="pa-0 mt-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          outlined
          @click="cancel"
        >
          Отмена
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Создать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { rules } from '@/helpers/validation'

export default {
  name: 'RoleCreateDialog',
  props: {
    show: { type: Boolean, default: false },
    cancellation: { type: Function, required: true },
  },
  data: () => ({
    rules,
    name: '',
    saving: false,
  }),
  watch: {
    show(opened) {
      if (opened) {
        this.name = ''
        if (this.$refs.form) this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    ...mapActions('role', { create: 'create' }),
    async save() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      try {
        await this.create(this.name)
        this.cancellation()
      } finally {
        this.saving = false
      }
    },
    cancel() {
      this.cancellation()
    },
  },
}
</script>
